import { ReactNode } from 'react';
import { Accordion, Icon } from 'semantic-ui-react';

type CollapsibleSectionPropsType<T extends string> = {
    title: ReactNode;
    sectionKey: T;
    activeSections: Set<T>;
    onToggle: (key: T) => void;
    className?: string;
    children: ReactNode;
};

function CollapsibleSection<T extends string>({
    title,
    sectionKey,
    activeSections,
    onToggle,
    className,
    children,
}: CollapsibleSectionPropsType<T>) {
    const active = activeSections.has(sectionKey);
    return (
        <Accordion fluid styled className={className} style={{ marginBottom: '1rem' }}>
            <Accordion.Title active={active} onClick={() => onToggle(sectionKey)}>
                <Icon name="dropdown" />
                {title}
            </Accordion.Title>
            <Accordion.Content active={active}>{children}</Accordion.Content>
        </Accordion>
    );
}

export default CollapsibleSection;
